export default "__VITE_ASSET__D1JQ_wtu__"